import { useState } from 'react';

import API from '../../../../../libs/api';
import useAsyncEffect from '../../../foundation/hooks/use-async-effect';
import useFetch from '../../../foundation/hooks/use-fetch/use-fetch';

export default function useFilesProviderMetadata({
  providerSettingId,
  locationId,
  forceInitialFetch = true,
} = {}) {
  const [filesProviderMetadata, setFilesProviderMetadata] = useState([]);

  const { fetching: loading, fetch, withFetch } = useFetch({ initialFetching: forceInitialFetch });

  async function fetchFilesProviderMetadata() {
    const data = await API.getBusinessFilesProviderMetadata({ providerSettingId, locationId });
    setFilesProviderMetadata(data);
  }

  async function updateFileProviderMetadata(fileId, payload) {
    await API.updateBusinessFileProviderMetadata(fileId, payload);
    await fetchFilesProviderMetadata();
  }

  async function bulkUpdateFileProviderMetadata(fileProvidersMetadata, { setId, locId }) {
    const payload = {
      providerSetting: setId || providerSettingId,
      location: locId || locationId,
      fileProvidersMetadata,
    };
    await API.bulkUpdateBusinessFileProviderMetadata(payload);
    await fetchFilesProviderMetadata();
  }

  useAsyncEffect(async () => {
    if (!forceInitialFetch) {
      return;
    }
    await fetch([fetchFilesProviderMetadata], { throwError: false });
  }, [providerSettingId, locationId]);

  return {
    filesProviderMetadata,
    loading,
    refresh: withFetch(fetchFilesProviderMetadata, { throwError: false }),
    updateFileProviderMetadata,
    bulkUpdateFileProviderMetadata,
  };
}
